import { getBranding, getIsBrandingPending } from '../../store/branding/branding.selectors';

import RecipientModule from './components/RecipientModule';

export { getBranding, getIsBrandingPending };

export default RecipientModule;
